import React from 'react';
import { Typography, Container, Grid, Paper, Card } from "@mui/material";

function GDE() {
    return (
        <Container disableGutters={false} maxWidth='xl'>
            <Grid container spacing={0}>
                <Grid item xs={12} md={1}>

                </Grid>
                <Grid item xs={12} md={10}>
                    <Paper elevation={5} sx={{ p: 2, minHeight: '85vh' }}>
                        <Typography variant="h5" sx={{ textAlign: 'center' }}>Guided Document Editor</Typography>
                        <Typography variant="body2" sx={{ textAlign: 'center' }}><a style={ {color:'grey' }} href="https://github.com/vinhub100/GuidedDocumentEditor" target='_blank' rel="noopener noreferrer">vinhub100/GuidedDocumentEditor</a></Typography>
                        <hr />
                        <div classname="yt">
                        <iframe style={{ minHeight:'60vh' }} width="100%" height="100%" src="https://www.youtube.com/embed/4VAb58_8EhM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </div>
                    </Paper>
                </Grid>

            </Grid>
        </Container>
    )
}

export default GDE;



